import React from 'react';
import { ACCENT_HEX, ACCENT_SOFT } from '../../lib/juniorTheme';
import {
  ATRAPA_RITMO_DIFFICULTIES,
  type AtrapaRitmoDifficulty,
} from '../../lib/game/atrapaRitmoEngine';

interface AtrapaRitmoLobbyProps {
  selected: AtrapaRitmoDifficulty;
  onSelect: (d: AtrapaRitmoDifficulty) => void;
  onStart: () => void;
}

export const AtrapaRitmoLobby: React.FC<AtrapaRitmoLobbyProps> = ({
  selected,
  onSelect,
  onStart,
}) => {
  return (
    <div className="w-full max-w-6xl mx-auto flex flex-col gap-8 sm:gap-10 py-4 sm:py-8">
      <p
        className="text-center text-base sm:text-xl font-extrabold leading-relaxed max-w-2xl mx-auto"
        style={{ color: '#6B6385' }}
      >
        Elige tu ritmo y toca los círculos de percusión cuando caigan las burbujas.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-7">
        {ATRAPA_RITMO_DIFFICULTIES.map((d, i) => {
          const hex = ACCENT_HEX[d.accent];
          const soft = ACCENT_SOFT[d.accent];
          const isSel = selected.id === d.id;
          return (
            <button
              key={d.id}
              type="button"
              onClick={() => onSelect(d)}
              className="junior-card-hover group relative flex min-h-[220px] sm:min-h-[260px] flex-col justify-between overflow-hidden rounded-[2rem] p-7 sm:p-8 text-left"
              style={{
                background: isSel
                  ? `linear-gradient(155deg, ${soft} 0%, rgba(255,255,255,0.96) 70%)`
                  : 'rgba(255,255,255,0.92)',
                border: `3px solid ${isSel ? hex : hex + '35'}`,
                boxShadow: isSel
                  ? `0 20px 48px -16px ${hex}70`
                  : `0 8px 28px -12px ${hex}30`,
              }}
            >
              <div
                className="absolute -right-10 -top-10 h-40 w-40 rounded-full opacity-30 blur-2xl"
                style={{ background: hex }}
                aria-hidden
              />

              <div className="relative z-10 flex items-start justify-between">
                <span className="text-xs font-extrabold tabular-nums tracking-widest" style={{ color: `${hex}99` }}>
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="junior-float text-6xl sm:text-7xl" style={{ animationDelay: `${i * 0.35}s` }} aria-hidden>
                  {d.emoji}
                </span>
              </div>

              <div className="relative z-10 mt-auto">
                <h3 className="junior-display text-[clamp(1.75rem,4vw,2.5rem)] leading-none" style={{ color: '#2A2540' }}>
                  {d.label}
                </h3>
                <p className="text-sm sm:text-base mt-3 leading-relaxed font-bold" style={{ color: '#6B6385' }}>
                  {d.description}
                </p>
                {isSel && (
                  <span className="inline-block mt-4 text-sm font-extrabold" style={{ color: hex }}>
                    Seleccionado ✓
                  </span>
                )}
              </div>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        onClick={onStart}
        className="w-full max-w-xl mx-auto py-5 sm:py-6 rounded-[1.75rem] font-extrabold text-white text-xl sm:text-2xl transition-transform hover:scale-[1.02] active:scale-[0.98]"
        style={{
          background: ACCENT_HEX[selected.accent],
          boxShadow: `0 20px 48px -12px ${ACCENT_HEX[selected.accent]}99`,
        }}
      >
        ¡A jugar! 🥁
      </button>
    </div>
  );
};

export default AtrapaRitmoLobby;
